import type { SlowboatPassportInput } from "../../../api/admin/slowboat/slowboatAdminApi";

const passportFields: Array<keyof SlowboatPassportInput> = [
  "title",
  "first_name",
  "last_name",
  "date_of_birth",
  "passport_no",
  "passport_country",
  "passport_expiry_date",
  "group_label",
];

export function normalizeRow(row: Record<string, unknown>, rowIndex = 0): SlowboatPassportInput {
  const normalized = Object.fromEntries(
    Object.entries(row).map(([key, value]) => [
      key.trim().toLowerCase().replace(/\s+/g, "_"),
      value == null ? "" : String(value).trim(),
    ]),
  ) as Record<string, string>;
  if (normalized.passport_expiry && !normalized.passport_expiry_date) {
    normalized.passport_expiry_date = normalized.passport_expiry;
  }
  const missingFields = ["date_of_birth", "passport_country"].filter(field => !normalized[field]);
  if (missingFields.length > 0) {
    const rowNumber = typeof row.__rowNum__ === "number" ? row.__rowNum__ + 1 : rowIndex + 2;
    throw new Error(`Row ${rowNumber}: missing required passport fields: ${missingFields.join(", ")}`);
  }
  return Object.fromEntries(
    passportFields
      .filter(field => normalized[field] !== "")
      .map(field => [field, normalized[field]]),
  ) as SlowboatPassportInput;
}
